<template>
  <div class="container">
    <el-row :gutter="10">
      <el-col :span="16" class="left">
        <div class="mapBox">
          <baidu-map class="map" :style="style" :center="center" :zoom="zoom" scroll-wheel-zoom @ready="handler">
            <bm-marker :position="center"></bm-marker>
            <!--            <bm-view style="width: 100%; height: 480px; flex: 1;border-radius: 5px;"></bm-view>-->
          </baidu-map>
          <div class="mapBox_top">
            <div>昌华智慧园区</div>
            <div>
              <span>
<!--                13：06:40 2023年3月9日-->
                {{ timeNow }}
              </span> | 武汉 | 23º晴 湿度98%
            </div>
          </div>
          <div class="mapBox_pile">
            <div v-for="item in pileList" :key="item.id" class="mapBox_pile_item">
              <div>
                <img :src="item.icon">
              </div>
              <div style="text-align: right">
                <div class="mapBox_pile_item_counts" :style="'color: ' + item.color">{{ item.counts }}</div>
                <div style="font-size: 15px">{{ item.name }}</div>
              </div>
            </div>
          </div>
          <div class="mapBox_trigger">
            <div>宽屏</div>
            <i style="width: 20px; height: 20px"></i>
            <div>全屏</div>
          </div>
        </div>
        <div class="left_bottom">
          <img src="./images/01.png" style="width: 100%"/>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="right right_top">
          <div class="title">
            <div style="display: flex; align-items: center">
              <img src="./images/cdz.png" style="width: 70rem; height: 70rem; vertical-align: middle" alt="">
              <div class="titler">
                <div class="titleName">充电桩</div>
                <span @click.stop="isShowArea = !isShowArea">切换<img src="../../assets/img/change0.png" alt=""></span>
                <div v-if="isShowArea" ref="area" style="position: absolute">
                  <Href @closedArea='closedArea'></Href>
                </div>
              </div>
            </div>
            <button @click="handleBack">返回园区</button>
          </div>
          <div class="right_top_box">
            <div class="right_top_item">
              <div>今日售电</div>
              <div class="data">
                1264.71
                <span style="font-size: 12px">￥</span>
              </div>
            </div>
            <div class="right_top_item">
              <div>累计售电</div>
              <div class="data">
                24417.53
                <span style="font-size: 12px">￥</span>
              </div>
            </div>
            <div class="right_top_item">
              <div>使用状态</div>
              <div class="data state">
                2<span style="color: rgb(1, 171, 101)">/8</span>
                <div class="icon busy">忙</div>
                <div class="icon">闲</div>
              </div>
            </div>
            <div class="right_top_item">
              <div style="display: flex">
                当前费率时段[9:00 ~ 15:00]
                <el-button type="info" plain size="mini" style="padding: 0 2px; margin-left: 5px">修改</el-button>
              </div>
              <div class="data" style="display: flex">
                <el-row :gutter="10">
                  <el-col :span="12">
                    1.0726
                    <span style="font-size: 12px">￥</span>
                    <div style="transform: scale(0.7); text-align: center">电价</div>
                  </el-col>
                  <el-col :span="12">
                    0.3574
                    <span style="font-size: 12px">￥</span>
                    <div style="transform: scale(0.7); text-align: center">服务费</div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
        <div class="right right_middle">
          <div class="right_title">充电统计</div>
          <el-divider/>
          <div class="right_middle_chart" id="main"></div>
        </div>
        <div class="right right_bottom">
          <div class="right_title">运营动态</div>
          <el-divider/>
          <vue-seamless-scroll :data="scrollList" class="right_bottom_scroll">
            <ul class="infinite-list">
              <li v-for="i in scrollList" class="infinite-list-item">访客用户【{{
                  i.license
                }}】使用了交流充电[{{ i.no }}]，消费{{ i.price }}元。 {{ i.time }}前
              </li>
            </ul>
          </vue-seamless-scroll>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import pileQuickIcon from './images/04.png'
import pileSnowIcon from './images/03.png'
import pileIcon from './images/05.png'
import vueSeamlessScroll from 'vue-seamless-scroll'
import dayjs from 'dayjs'

const Href = () => import('@/views/HomePageOverview/components/href')

export default {
  name: "ChargingPile",
  components: {
    Href,
    vueSeamlessScroll
  },
  data() {
    return {
      list: [],
      dataList: [0, 0, 0, 0, 2, 5, 10, 45, 13, 32, 12, 1],
      scrollList: [
        {
          id: Math.random() * +new Date(),
          no: '56111...',
          price: 34.12,
          license: '鄂A15571C',
          time: '10分钟'
        }, {
          id: Math.random() * +new Date(),
          no: '56135...',
          price: 102.5,
          license: '浙H88483K',
          time: '34分钟'
        }, {
          id: Math.random() * +new Date(),
          no: '56124...',
          price: 98.36,
          license: '鄂E96963H',
          time: '35分钟'
        }, {
          id: Math.random() * +new Date(),
          no: '56123...',
          price: 45.28,
          license: '浙K11895A',
          time: '1小时'
        }, {
          id: Math.random() * +new Date(),
          no: '56122...',
          price: 22.16,
          license: '鄂B22295A',
          time: '3小时'
        }, {
          id: Math.random() * +new Date(),
          no: '56122...',
          price: 77.00,
          license: '豫E54471C',
          time: '1天'
        }, {
          id: Math.random() * +new Date(),
          no: '57158...',
          price: 60.31,
          license: '鄂A66312B',
          time: '1天'
        },
      ],
      center: {lng: 0, lat: 0},
      zoom: 0,
      pileList: [
        {
          id: Math.random() * +new Date(),
          icon: pileSnowIcon,
          counts: 8,
          name: '交流电桩',
          color: 'rgb(30, 145, 230)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileQuickIcon,
          counts: 2,
          name: '直流电桩',
          color: 'rgb(30, 145, 230)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileIcon,
          counts: 3,
          name: '离线（枪）',
          color: 'rgb(204, 204, 204)'
        }, {
          id: Math.random() * +new Date(),
          icon: pileIcon,
          counts: 0,
          name: '故障（枪）',
          color: 'rgb(253, 52, 42)'
        },
      ],
      style: {
        width: 100 + '%',
        height: 55 + 'vh'
      },
      isShowArea: false,
      timeNow: '',
      timer: ''
    }
  },
  created() {
    this.handleList()
    this.NowTime()
  },
  mounted() {
    this.handleSetInter()
    this.init()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    handleBack() {
      this.$router.push({
        path: '/SubstationManagement'
      })
    },

    handleList() {
      for (let i = 0; i < 24; i++) {
        if (i % 2 === 0) {
          this.list.push(i + '点')
        }
      }
    },

    init() {
      let myChart = echarts.init(document.getElementById('main'));
      let option = {
        grid: {
          top: "15%",
          bottom: "15%",
          width: 'auto',
          height: 'auto'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        xAxis: {
          type: 'category',
          data: this.list
        },
        yAxis: {
          type: 'value',
          name: '次数'
        },
        series: [
          {
            data: this.dataList,
            type: 'line',
            smooth: true
          }
        ]
      };

      option
      &&
      myChart.setOption(option)
    },

    handler({BMap, map}) {
      this.center.lng = 114.144838
      this.center.lat = 30.464727
      this.zoom = 30
    },

    closedArea() {
      this.isShowArea = false
    },

    NowTime() {
      this.timeNow = dayjs().format('HH:mm:ss YYYY年MM月DD日')
    },

    // 计时器
    handleSetInter() {
      this.timer = setInterval(() => {
        this.NowTime()
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
h1 {
  font-size: 25px !important;
  height: 20%;
}

.container {
  .left {
    .mapBox {
      position: relative;
      overflow: hidden;

      .mapBox_top {
        width: 100%;
        height: 50px;
        color: #FFFFFF;
        font-size: 18px;
        position: absolute;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(180deg, rgb(101, 99, 98), rgba(101, 99, 98, 0));
        padding: 0 15px;
      }

      .mapBox_pile {
        position: absolute;
        top: 100px;
        left: 15px;

        .mapBox_pile_item {
          width: 200px;
          background-color: #fff;
          padding: 10px;
          margin-bottom: 5px;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          overflow: hidden;

          .mapBox_pile_item_counts {
            font-size: 20px;
            font-weight: 600;
            font-family: "Microsoft YaHei";
          }
        }
      }

      .mapBox_trigger {
        width: 100%;
        height: 50px;
        color: #FFFFFF;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        background: linear-gradient(0deg, rgb(101, 99, 98), rgba(101, 99, 98, 0));
        padding: 0 15px;

        div {
          cursor: pointer;
        }
      }
    }

    .left_bottom {
      font-size: 0;
      background-color: #fff;
    }
  }

  .right {
    height: calc(32vh - 25px);
    margin-bottom: 10px;
    background-color: #fff;
  }

  .right_top {
    background: url('./images/02.png') no-repeat 375px 15px #fff;
    padding: 15px;

    .title {
      height: 30%;
      font-size: 18rem;
      font-weight: bold;
      margin-bottom: 10rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      position: relative;

      .titleName {
        color: #333;
        font-weight: bold;
        font-size: 36rem;
      }

      span {
        margin-top: 10rem;
        font-size: 16rem;
        color: #999;
        font-weight: 400;
        cursor: pointer;

        img {
          width: 17rem;
          margin-left: 5rem;
        }
      }

      button {
        width: 84px;
        height: 24px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4rem;
        font-size: 16rem;
        font-weight: 400;
        color: #999;
        cursor: pointer;
      }
    }

    .right_top_box {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      height: 70%;

      .right_top_item {
        width: 50%;
        padding: 0 10px 10px 0;
        font-size: 15px;

        .data {
          color: rgb(13, 148, 255);
          font-size: 18px;
          margin-top: 5px;
          font-weight: 600;
        }

        .state {
          display: flex;
          align-items: center;

          .icon {
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            color: #FFFFFF;
            background-color: rgb(1, 171, 101);
            margin: 0 5px;
            border-radius: 50%;
          }
        }

        .busy {
          background-color: rgb(13, 148, 255) !important;
        }
      }
    }

  }

  .right_middle {
    .right_middle_chart {
      width: 100%;
      height: calc(100% - 95px);
    }
  }

  .right_title {
    height: 47px;
    line-height: 23px;
    font-size: 15px;
    font-weight: 500;
    padding: 24px 0 0 15px;
  }

  .right_bottom {
    .right_bottom_scroll {
      padding: 0 15px;
      height: calc(32vh - 120px);
      overflow: hidden;

      .infinite-list {
        height: 100%;

        .infinite-list-item {
          height: 42px;
          background-color: rgb(245, 245, 245);
          margin-bottom: 5px;
          padding: 0 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
        }
      }
    }
  }

}

</style>